module.exports = __webpack_public_path__ + "img/zwgd.f5c8ca4a.png";